import { Cloud, Cpu, Database, Layers3, HardDrive, Workflow, type LucideIcon } from "lucide-react";
import type { CategoryId } from "@/lib/comparison-catalog";
export const categoryIcons: Record<CategoryId, LucideIcon> = { ai: Cpu, cloud: Cloud, databases: Database, embeddings: Layers3, storage: HardDrive, queues: Workflow };
